import PropTypes from 'prop-types';
import React from 'react';

import { TableExperimentalContextProvider } from './TableExperimentalContext';
import { TableProps } from './TableTypes';

import { forwardRef } from 'system';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TableExperimentalProps = TableProps<any>;

export const propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  columns: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onRowSelectionChange: PropTypes.func,
  onSortingChange: PropTypes.func,
  enableSorting: PropTypes.bool,
  defaultSorting: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  disableRowHoverStyle: PropTypes.bool,
  isStickyHeader: PropTypes.bool,
  isStickyFirstColumn: PropTypes.bool,
  isFetching: PropTypes.bool
};

export const defaultProps = {
  data: [],
  enableSorting: false,
  defaultSorting: [],
  disableRowHoverStyle: false,
  isStickyHeader: false,
  isStickyFirstColumn: false,
  isFetching: false
};

const TableExperimentalProvider = forwardRef(
  (props: TableExperimentalProps, ref: React.MutableRefObject<HTMLTableElement>): React.ReactElement => {
    const {
      data,
      columns,
      rowSelection,
      onRowClick,
      setRowSelection,
      onSortingChange,
      enableSorting,
      defaultSorting,
      disableRowHoverStyle,
      isStickyHeader,
      isStickyFirstColumn,
      sx,
      children,
      pagination,
      setPagination,
      pageCount,
      isFetching,
      setColumnVisibility,
      columnVisibility,
      columnOrder,
      setColumnOrder,
      ...rest
    } = props;

    const tableSelfProps = {
      disableRowHoverStyle,
      isStickyHeader,
      isStickyFirstColumn,
      sx,
      ...rest
    };

    const contextProviderProps = {
      data,
      columns,
      rowSelection,
      onRowClick,
      setRowSelection,
      onSortingChange,
      defaultSorting,
      enableSorting,
      pagination,
      setPagination,
      pageCount,
      ref,
      isFetching,
      setColumnVisibility,
      columnVisibility,
      tableSelfProps,
      columnOrder,
      setColumnOrder
    };

    return (
      <TableExperimentalContextProvider {...contextProviderProps} ref={ref}>
        {children}
      </TableExperimentalContextProvider>
    );
  }
);

TableExperimentalProvider.displayName = 'TableExperimentalProvider';
TableExperimentalProvider.propTypes = propTypes;
TableExperimentalProvider.defaultProps = defaultProps;

export default TableExperimentalProvider;
